/**
 * @flow
 * @relayHash 2a9d8665dbf5ed669489231d502662e5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BlockEdit_viewer$ref = any;
export type queries_blockEditFormQueryVariables = {|
  id: string
|};
export type queries_blockEditFormQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: BlockEdit_viewer$ref
  |}
|};
export type queries_blockEditFormQuery = {|
  variables: queries_blockEditFormQueryVariables,
  response: queries_blockEditFormQueryResponse,
|};
*/


/*
query queries_blockEditFormQuery(
  $id: ID!
) {
  viewer {
    ...BlockEdit_viewer_1Bmzm5
    id
  }
}

fragment BlockEdit_viewer_1Bmzm5 on Viewer {
  ...ArticleSelector_viewer
  id
  block(id: $id) {
    id
    title
    active
    slug
    linkedArticles {
      article {
        id
        title
      }
      title
      id
    }
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = [
  v1,
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_blockEditFormQuery",
  "id": null,
  "text": "query queries_blockEditFormQuery(\n  $id: ID!\n) {\n  viewer {\n    ...BlockEdit_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment BlockEdit_viewer_1Bmzm5 on Viewer {\n  ...ArticleSelector_viewer\n  id\n  block(id: $id) {\n    id\n    title\n    active\n    slug\n    linkedArticles {\n      article {\n        id\n        title\n      }\n      title\n      id\n    }\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_blockEditFormQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "BlockEdit_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_blockEditFormQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": v3
              }
            ]
          },
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "block",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID"
              }
            ],
            "concreteType": "Block",
            "plural": false,
            "selections": [
              v1,
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "slug",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "linkedArticles",
                "storageKey": null,
                "args": null,
                "concreteType": "BlockItem",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "article",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Article",
                    "plural": false,
                    "selections": v3
                  },
                  v2,
                  v1
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f1f890b2173b9e768833536b70827f4';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_blockEditFormQuery.graphql.js